module.exports = __webpack_public_path__ + "a76f7d93.png";